import {Box} from '@mui/material';
import {ReactComponent as HorizontalResize} from '../../../assets/images/Horizontal-resize.svg';
import {useCallback} from 'react';

export const HorizontalColumnResize = ({
  side,
  isResizingRef,
  sideBeingResizedRef,
}: {
  side: string;
  isResizingRef: React.RefObject<boolean>;
  sideBeingResizedRef: React.RefObject<string | null>;
}) => {
  const startHorizontalResize = useCallback(
    (side: string) => {
      isResizingRef.current = true;
      sideBeingResizedRef.current = side;
      document.body.style.cursor = 'col-resize';
    },
    [isResizingRef, sideBeingResizedRef]
  );
  return (
    <Box className="h-resize" onMouseDown={() => startHorizontalResize(side)}>
      <HorizontalResize />
    </Box>
  );
};
